export default {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
}
